import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { takeLatest } from 'redux-saga/effects';
import { IUser } from '../../model/user/IUser';

export const actionTypes = {
    Login: '[Login] Action',
    Logout: '[Logout] Action',
    Verify: '[Verify] Action',
    Register: '[Register] Action',
    SetUser: '[Set User] Action',
    SetUserACL: '[Set User Acl] Action',
};

interface IAuthState {
    user: IUser | undefined;
    authToken: string | undefined;
    isVerified: boolean;
}

const initialAuthState: IAuthState = {
    user: undefined,
    authToken: undefined,
    isVerified: false,
};

export const reducer = persistReducer<any, any>(
    { storage, key: 'auth', whitelist: ['user', 'authToken', 'isVerified'] },
    (state = initialAuthState, action) => {
        switch (action.type) {
            case actionTypes.Login: {
                const { authToken } = action.payload;
                return { ...state, authToken };
            }

            case actionTypes.Register: {
                const { authToken } = action.payload;
                return { authToken, user: undefined };
            }

            case actionTypes.Verify: {
                return { ...state, isVerified: true };
            }

            case actionTypes.Logout: {
                return initialAuthState;
            }

            case actionTypes.SetUser: {
                const { user } = action.payload;
                return { ...state, user };
            }

            case actionTypes.SetUserACL: {
                const { acl } = action.payload;
                return { ...state, user: { ...state.user, adminAcl: acl } };
            }

            default:
                return state;
        }
    }
);

export const actions = {
    login: (authToken: string) => ({ type: actionTypes.Login, payload: { authToken } }),
    verify: () => ({ type: actionTypes.Verify }),
    register: (authToken: string) => ({
        type: actionTypes.Register,
        payload: { authToken },
    }),
    logout: () => ({ type: actionTypes.Logout }),
    setUser: (user: IUser) => ({ type: actionTypes.SetUser, payload: { user } }),
    setAcl: (aclArr: string[]) => ({ type: actionTypes.SetUserACL, payload: { aclArr } }),
};

export function* saga() {
    yield takeLatest(actionTypes.Login, function* loginSaga() {
        //
    });
}
